import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {


  public HOME_URL = environment.serverUrl;
  public FILE_EXTNS = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'pdf', 'PDF'];

  constructor() { }

  public MESSAGES: any = {
    'ERROR': "Could not perform the request",
    'UNAUTHORIZED': "You're not authorized to access this page",
    'FORBIDDEN': "You don't have permission to access this page"
  }

  public RESPONSE_CODES: any = {
    'SUCCESS': '200'
  }

  // Server Url
  public SERVER_URLS: any = {
    'IMAGE_URL': 'file/image/',
    'FILE_VIEW': 'file/view/',
    'LOGIN': 'user/login',
    'FORGOT_PASSWORD': 'user/forgot-password',
    'RESET_PASSWORD': 'user/reset-password',
    'ROLE': 'role',
    'ROLE_ACTIVE': 'role/active',
    'SLIDER': 'slider/active',
    'BOARD_MEMBERS': 'board-members/active',
    'ANNOUNCEMENTS_COUNTS': 'content/announcements-count',
    'IMPORTANT_lINKS_COUNTS': 'content/links-count',
    'USER_DROPDOWN': 'user/dropdown',
    'USER': 'user',
    'GALLERY': 'gallery',
    'USER_PROFILE': 'user/profile',
    'GALLERY_ACTIVE': 'gallery/active',
    'USER_PROFILES': 'user/user-profile',
    'ADMIN_PROFILE': 'user/admin/profile',
    'CHANGE_USER_STATUS': 'user/change-status',
    'CHANGE_PASSWORD': 'user/profile/change-password',
    'LATEST_NEWS_COUNTS': 'content/latest-news-count',
    'QUICK_LINK_COUNTS': 'content/quick-link-count',
    'CONTENT': 'content/latest',
    'COUNTRY': 'country',
    'COUNTRY_ACTIVE': 'country/active',
    'STATE': 'state',
    'CITY': 'city/',
    'CITY_ACTIVE': 'city/active',
    'ALLERGY': 'allergy',
    'CUISINE': 'cuisine',
    'WORK': 'work',
    'WORK_ACTIVE': 'work/active',
    'DAILY_ACTIVITY': 'dailyactivity',
    'MEDICAL_CONDITION': 'medical-condition',
    'EMOTIONAL_CONDITION': 'emotional-condition',
    'REPORT_DOWNLOAD': 'report/download',
    'NOTIFICATION_MASTER': 'notification-master',
    'GOSHALA_REGISTER': 'sanstha/registration',
    'GOSHALA_ACTIVE': 'sanstha/active',
    'DISTRICT_ACTIVE': 'district/active',
    'TALUKA_ACTIVE': 'taluka/active/',
    'NOTICE': 'notice/active',
    'DONATION': 'donation/donate',
    'GRIEVANCE_REGISTER': 'grievance/add',
    'SANSTHA_LOGIN': 'user/sanstha/login',
    'SANSTHA_FORGOT_PASSWORD': 'user/sanstha/forgot-password',
    'SANSTHA': 'sanstha',
    'SANSTHA_CHANGE_STATUS': 'sanstha/change-status/',
    'USER_SANSTHA_DETAILS': 'sanstha/user-sanstha',
    'SANSTHA_BANK': 'sanstha/bank/',
    'SANSTHA_DOCUMENT': 'sanstha/document/',
    'SANSTHA_PROPERTY': 'sanstha/property/',
    'SANSTHA_BASIC_DETAILS': 'sanstha/basic/',
    'SANSTHA_ANIMAL_DETAILS': 'sanstha/animal/',
    'SANSTHA_UPDATE_MEMBER': 'sanstha/members/',
    'SANSTHA_UPDATE_EMPLOYEE': 'sanstha/employee/',
    'DAILY_PROGRAM': 'daily-programs/public',
    'UPLOAD_OLD_SANSTHA_DOCUMENTS': 'sanstha/documents/old',
    'UPLOAD_NAMUNA_THREE': 'sanstha/namuna-three/',
    'ATTENDANCE_SUBMIT': 'attendance',
    'ATTENDANCE_GET': 'attendance',
    'ATTENDANCE_IMPORT_EXCEL': 'attendance/import-excel',
    'UPLOAD_SELF_DECLARATION': 'sanstha/self-declaration',
    'ATTENDANCE_LIST': 'attendance/list',
    'CHARA_PURCHASE': 'chara-purchase',
    'CHARA_PURCHASE_LIST': 'chara-purchase/list',
    'UPLOAD_EXCEL_PDF': 'sanstha/excel-pdf',
    'FINANCIAL_ENTRY_LIST': 'goshala-financial-entry/list',
    'FINANCIAL_ENTRY': 'goshala-financial-entry',
    'COWS_INFO': 'cows-info',
    'COWS_BY_CATEGORY': 'cows-info/category',
    'UPDATE_SELF_DECLARATION': 'sanstha/self-declaration',
    'UPDATE_EXCEL_PDF': 'sanstha/excel-pdf',
    'GOSHALA_FINANCIAL_ENTRY': 'goshala-financial-entry',
    'GOSHALA_FINANCIAL_LIST': 'goshala-financial-entry/list',
    'ATTENDANCE_WEEKLY_SUBMIT': 'attendance/weekly',
    'ATTENDANCE_WEEKLY_PREVIOUS': 'attendance/weekly/previous',
    'ATTENDANCE_WEEKLY_LIST': 'attendance/weekly/list',
    'ATTENDANCE_ANIMAL_IS_FIRST_TIME': 'attendance/animal/is-first-time',
    'ATTENDANCE_ANIMAL_INITIAL_CENSUS': 'attendance/animal/initial-census',
    'ATTENDANCE_ANIMAL_ROSTER': 'attendance/animal/roster',
    'ATTENDANCE_ANIMAL_CENSUS_START': 'attendance/animal/census/start',
    'ATTENDANCE_ANIMAL_CENSUS_BATCH': 'attendance/animal/census/batch',
    'ATTENDANCE_ANIMAL_CENSUS_PROGRESS': 'attendance/animal/census/progress',
    'ATTENDANCE_ANIMAL_CENSUS_FINALIZE': 'attendance/animal/census/finalize',
    'ATTENDANCE_ANIMAL_CENSUS_UPDATE_ENTRY': 'attendance/animal/census/entry',
    'ATTENDANCE_WEEKLY_LATEST': 'attendance/weekly/latest',
    'ATTENDANCE_WEEKLY_CUMULATIVE': 'attendance/weekly/cumulative',
    'COMPLETE_PROFILE': 'user/complete-profile',
    'ATTENDANCE_ANIMAL_CENSUS_UPDATE_TARGET_COUNT': 'attendance/animal/census/target-count',
    'ATTENDANCE_ANIMAL_CENSUS_DELETE_ENTRY': 'attendance/animal/census/entry',
    'ATTENDANCE_WEEKLY_UPDATE': 'attendance/weekly/update',
    'SCHEME_ACTIVE': 'scheme/active',
    'GET_BENEFIT_YEARS': 'benefit',
    'APPLICANTDETAILS': 'application/applicant',
    'REUPLOAD_DOCUMENT': 'application/reupload/',
    'REUPLOAD_ADDITIONAL_DOCUMENT': 'application/reupload/',
    'REUPLOAD_GOVARDHAN_DOCUMENT': 'application/govardhan-govansh/reupload/',
    'APPLICANT_BANK_UPDATE': 'application/update-bank/',
    'APPLICANT_BASIC_DETAILS_UPDATE': 'application/update-basic-details/'
  }

  public VALIDATION_PATTERNS: any = {
    'EMAIL': '^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$',
    'MOBILE': '(^$|[0-9]{10})',
    'ZIP_CODE': '(^$|[0-9]{6})'
  }

  public getSessionStorage(): Storage | null {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  }

  public getAuthHeader() {
    const storage = this.getSessionStorage();
    if (storage && storage.getItem('currentUser')) {
      let user = JSON.parse(storage.getItem('currentUser')!);
      return 'Bearer ' + (user && user.sessionToken ? user.sessionToken : '');
    } else {
      return '';
    }
  }


  public convertToBase64(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => result.next(reader.result!.toString());
    return result;
  }

  public hasModulePermission(moduleName: string, action: string): boolean {
    const storage = this.getSessionStorage();
    if (storage && storage.getItem('currentUser')) {
      try {
        const currentUser = JSON.parse(storage.getItem('currentUser')!);
        if (!currentUser) return false;

        const roleName = currentUser.role?.name?.toUpperCase() || '';
        if (roleName === 'ADMIN' || roleName === 'SUPER_ADMIN' || roleName === 'SUPERADMIN') {
          return true;
        }

        const permissions = currentUser.role?.permissions || currentUser.permissions || currentUser.role?.modulePermissions || [];
        if (Array.isArray(permissions) && permissions.length > 0) {
          return permissions.some((p: any) => {
            if (typeof p === 'string') {
              const upper = p.toUpperCase();
              return upper === `${moduleName}_${action}`.toUpperCase() || upper === moduleName.toUpperCase() || upper === 'ALL';
            }
            const mod = (p.moduleName || p.module?.name || p.name || '').toUpperCase();
            if (mod === moduleName.toUpperCase() || mod === 'ALL') {
              if (action.toUpperCase() === 'ADD') return !!(p.canAdd ?? p.add ?? true);
              if (action.toUpperCase() === 'UPDATE') return !!(p.canUpdate ?? p.update ?? p.canEdit ?? p.edit ?? true);
              if (action.toUpperCase() === 'VIEW') return !!(p.canView ?? p.view ?? p.canRead ?? p.read ?? true);
              if (action.toUpperCase() === 'DELETE') return !!(p.canDelete ?? p.delete ?? false);
              return true;
            }
            return false;
          });
        }

        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  public hasPermission(...args: string[]) {
    let hasPermission = false;
    if (sessionStorage.getItem('currentUser')) {
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser')!);
      if (args.indexOf(currentUser.role.name) > -1) {
        hasPermission = true;
      }
    }
    return hasPermission;
  }

  public getImageUrl(imageName: string) {
    return this.HOME_URL + this.SERVER_URLS['IMAGE_URL'] + imageName + '/';
  }

  public checkIfNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public checkIfLetter(event: any): void {
    const pattern = /^[A-Za-z\s]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  public checkIfMarathiLetter(event: any): void {
    const pattern = /^[a-zA-Z\s\u0900-\u097F]+$/;

    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  public checkIfAlphanumeric(event: any): void {
    const pattern = /^[A-Za-z0-9\s.,]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public validateString(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;

    // Prevent space at the beginning
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }

    // Prevent consecutive spaces
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }

    // Allow any other characters (numbers, symbols, etc.)
    // No need to prevent anything else
  }



  public checkNoStartingOrConsecutiveSpaces(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
  }

  public checkBankAccountNumber(event: any): void {
    const inputValue = event.target.value;
    const inputChar = event.data;

    const minLength = 10;
    const maxLength = 16;

    if (inputValue.length > maxLength) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ') {
      event.preventDefault();
      return;
    }
    if (!/^[0-9]*$/.test(inputChar)) {
      event.preventDefault();
      return;
    }
    if (inputValue.length < minLength) {
      // Handle feedback (e.g., show a message or alert) if necessary
    }
  }



  public checkNoStartingOrConsecutiveSpacesForAddress(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
  }

  public checkMaxLength(event: any): void {
    let input = event.target.value;
    input = input.replace(/[+-]/g, '');
    if (input.length > 2) {
      input = input.slice(0, 2);
    }
    event.target.value = input;
  }

  public dontAcceptSign(event: any): void {
    let input = event.target.value;
    input = input.replace(/[+-]/g, '');
    if (input.length > 0) {
      input = input.slice(0, 25);
    }
    event.target.value = input;
  }



  public onlyNumber(event: any): void {
    const pattern = /^[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return;
    }
    if (inputChar === '+' || inputChar === '-' || inputChar === ' ' || inputChar === '.' || inputChar === ',') {
      event.preventDefault();
      return;
    }
  }

  public checkFileExtension(fileExt: string) {
    if (this.FILE_EXTNS.indexOf(fileExt) > -1)
      return true;
    else
      return false;
  }

  /**
     * Success Message Method
     */
  public successMsg(message: string) {
    if (typeof document !== 'undefined') {
      // Hide error snackbar if it's open
      //var erEl = document.getElementById("error-snackbar");
      //erEl.className = erEl.className.replace("show", "");

      var x = document.getElementById("success-snackbar");
      x.innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i>&nbsp;&nbsp;' + message;
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);
    }
  }

  /**
   * Error Message Method
   */
  public errorMsg(message: string) {
    if (typeof document !== 'undefined') {
      var x = document.getElementById("error-snackbar");
      document.getElementById("error-msg-disp").innerHTML = message;
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);
    }
  }
}
